import { Link } from "react-router-dom";
import { ArrowRight, CircleCheck, Tag } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { usePaywall } from "@/context/PaywallContext";

const INCLUDED = [
  "SVG, EPS, AI, PDF + 2048px PNG & JPG",
  "Greyscale & outline versions",
  "Re-colours and AI redesigns of the same logo",
  "Brand guidelines PDF with matched fonts",
  "Social kit and iPhone sticker pack",
];

export const PricingSection = () => {
  const { user } = useAuth();
  const paywall = usePaywall();
  const cta = "inline-flex items-center gap-2 bg-[#ED5A24] hover:bg-[#0A0A0B] text-white text-xs uppercase tracking-[0.2em] font-bold h-12 px-8 transition-colors duration-200";

  return (
    <section className="border-b border-black/5" data-testid="pricing-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 md:py-28 grid grid-cols-1 md:grid-cols-12 gap-10 items-center">
        <div className="md:col-span-5">
          <div className="text-xs uppercase tracking-[0.3em] font-bold text-[#52525B] mb-3">04 — Pricing</div>
          <h2 className="text-3xl md:text-4xl tracking-tight font-bold leading-tight mb-4">
            Preview free.<br /><span className="text-[#ED5A24]">Pay per logo.</span>
          </h2>
          <p className="text-base text-[#52525B] leading-relaxed">
            Upload and preview as many logos as you like. Only pay for the ones you want — one payment unlocks every file for that logo.
          </p>
        </div>
        <div className="md:col-span-7">
          <div className="border-2 border-[#0A0A0B] p-8 md:p-10 shadow-[12px_12px_0_0_#ED5A24]" data-testid="pricing-card">
            <div className="flex items-center justify-between mb-6">
              <span className="text-[10px] uppercase tracking-[0.25em] font-bold bg-[#0A0A0B] text-white px-2.5 py-1">Per logo</span>
              <Tag className="w-6 h-6 text-[#ED5A24]" />
            </div>
            <div className="flex items-baseline gap-3 mb-1" data-testid="pricing-price">
              <span className="text-6xl font-black tracking-tighter">{paywall.price}</span>
              <span className="text-sm text-[#52525B]">per logo · GST included</span>
            </div>
            <p className="text-sm text-[#52525B] mb-8">No subscription. No credits. No watermark.</p>
            <ul className="space-y-2.5 mb-10">
              {INCLUDED.map((p) => (
                <li key={p} className="flex items-center gap-3 text-sm"><CircleCheck className="w-4 h-4 text-[#ED5A24] shrink-0" strokeWidth={2.5} />{p}</li>
              ))}
            </ul>
            <Link to={user ? "/dashboard" : "/register"} className={cta} data-testid="pricing-cta">
              {user ? "Go to dashboard" : "Start free"} <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
